import Vue from "vue"
import Vuetify from "vuetify"
import "vuetify/src/stylus/app.styl"

/*
TODO: We can minimize the amount of Vuetify used by selectively importing only the components that we need.
See https://vuetifyjs.com/en/framework/a-la-carte for reference.
*/


Vue.use(Vuetify, {
  iconfont: "mdi",
})
